import axiosInstance from "../helpers/axiosInstance"

export const fetchAutomatedShippingCoverageDeactivations = async (params) => {
  const res = await axiosInstance.get(
    `${process.env.REACT_APP_PLATFORM_URL}/api/v1/automated-shipping-coverage-deactivations`,
    { params }
  )
  return res.data
}

export const acknowledgeAutomatedShippingCoverageDeactivation = async (id) => {
  const res = await axiosInstance.patch(
    `${process.env.REACT_APP_PLATFORM_URL}/api/v1/automated-shipping-coverage-deactivations/${id}/acknowledge`
  )
  return res.data
}
